// extracted by mini-css-extract-plugin
export default {"remove_room":"child_remove_room__p-MwM"};